import React, { useEffect, useState } from 'react';
import './Hero.css';
import poster4 from '../Assets/demo_part.jpg';
import { API_BASE } from '../../config/api';

const DEFAULT_SLIDE = {
  imageUrl: poster4,
  title: '',
  subtitle: '',
};

const normalizeSlides = (data) => {
  const rawSlides =
    Array.isArray(data?.items) && data.items.length > 0
      ? data.items
      : [data];

  const slides = rawSlides
    .map((slide) => ({
      imageUrl: String(slide?.imageUrl || '').trim(),
      title: String(slide?.title || '').trim(),
      subtitle: String(slide?.subtitle || '').trim(),
    }))
    .filter((slide) => slide.imageUrl || slide.title || slide.subtitle)
    .map((slide) => ({
      ...slide,
      imageUrl: slide.imageUrl || poster4,
    }));

  return slides.length ? slides : [DEFAULT_SLIDE];
};

const Hero = () => {
  const [slides, setSlides] = useState([DEFAULT_SLIDE]);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    fetch(`${API_BASE}/hero-banner`)
      .then((res) => res.json())
      .then((data) => {
        setSlides(normalizeSlides(data));
        setActiveIndex(0);
      })
      .catch(() => {
        setSlides([DEFAULT_SLIDE]);
        setActiveIndex(0);
      });
  }, []);

  useEffect(() => {
    if (slides.length <= 1) {
      setActiveIndex(0);
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setActiveIndex((currentIndex) => (currentIndex + 1) % slides.length);
    }, 5000);

    return () => window.clearInterval(intervalId);
  }, [slides]);

  return (
    <div className="hero">
      {slides.map((slide, index) => (
        <div
          key={`${slide.imageUrl}-${index}`}
          className={`hero-slide ${index === activeIndex ? 'hero-slide-active' : ''}`}
          aria-hidden={index !== activeIndex}
        >
          <img
            src={slide.imageUrl}
            alt={slide.title || 'Jewellery Display'}
            className="hero-background"
          />
          {(slide.title || slide.subtitle) && (
            <div className="hero-content">
              {slide.title && <h1>{slide.title}</h1>}
              {slide.subtitle && <p>{slide.subtitle}</p>}
            </div>
          )}
        </div>
      ))}

      {slides.length > 1 && (
        <div className="hero-indicators" aria-label="Hero banner slideshow indicators">
          {slides.map((slide, index) => (
            <button
              key={`indicator-${slide.imageUrl}-${index}`}
              type="button"
              className={`hero-indicator ${index === activeIndex ? 'hero-indicator-active' : ''}`}
              onClick={() => setActiveIndex(index)}
              aria-label={`Show banner ${index + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Hero;
